import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [isLogin, setIsLogin] = useState(true);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const endpoint = isLogin ? "/admin/login" : "/admin/register";
      const response = await axios.post(`${API}${endpoint}`, formData);
      
      localStorage.setItem("adminToken", response.data.token);
      localStorage.setItem("adminUsername", response.data.username);
      
      toast.success(isLogin ? "Login successful!" : "Registration successful!");
      navigate("/admin/dashboard");
    } catch (error) {
      console.error("Auth error:", error);
      toast.error(error.response?.data?.detail || "Authentication failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#F7F4F0] to-[#F7F4F0] py-12 px-4 sm:px-6 lg:px-8">
      <Card className="w-full max-w-md" data-testid="admin-login-card">
        <CardHeader>
          <CardTitle className="text-2xl text-center" data-testid="admin-login-title">
            {isLogin ? "Admin Login" : "Admin Registration"}
          </CardTitle>
          <CardDescription className="text-center">
            {isLogin ? "Sign in to manage your site" : "Create an admin account"}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="admin-login-form">
            <div>
              <Label htmlFor="username">Username</Label>
              <Input
                id="username"
                name="username"
                data-testid="admin-username-input"
                value={formData.username}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                name="password"
                type="password"
                data-testid="admin-password-input"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>
            <Button
              type="submit"
              className="w-full btn-primary"
              disabled={loading}
              data-testid="admin-login-submit"
            >
              {loading ? "Please wait..." : isLogin ? "Sign In" : "Register"}
            </Button>
          </form>
          <div className="mt-4 text-center">
            <button
              type="button"
              onClick={() => setIsLogin(!isLogin)}
              className="text-sm text-[#8B7355] hover:text-[#8B7355]"
              data-testid="toggle-auth-mode"
            >
              {isLogin ? "Need an account? Register" : "Already have an account? Login"}
            </button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
